import { useQuery } from "@tanstack/react-query";
import { voucherCategoriesService } from "@/shared/services/voucherCategories.service";
import { VoucherCategoriesResponse } from "@/shared/types/voucherCategories.types";

export const useVoucherCategories = () => {
  return useQuery<VoucherCategoriesResponse>({
    queryKey: ["voucherCategories"],
    queryFn: voucherCategoriesService.getVoucherCategories,
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24 * 7,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
